var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttention(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E05A5C",
    fillRule: "evenodd",
    d: "M10 3.182a6.818 6.818 0 1 0 0 13.636 6.818 6.818 0 0 0 0-13.636ZM1.667 10a8.333 8.333 0 1 1 16.667 0 8.333 8.333 0 0 1-16.667 0ZM10 6.212c.419 0 .758.34.758.758V10a.758.758 0 0 1-1.515 0V6.97c0-.419.339-.758.757-.758Zm0 6.06a.758.758 0 1 0 0 1.516h.008a.758.758 0 0 0 0-1.515H10Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttention);
export default __webpack_public_path__ + "static/media/attention.e5e108d3154e17dd1db3b02024b7b6e5.svg";
export { ForwardRef as ReactComponent };